import React from 'react';

const EricssonLogo: React.FC = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="32 25 55 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g id="Econ" fill="var(--colorNeutralForeground1)">
          <path d="M81.969,28.435c-0.587-1.736-1.811-3.059-3.322-3.821c-1.523-0.749-3.322-0.937-6.306,0.062L38.475,35.965
			c-2.997,0.999-4.321,2.223-5.082,3.734c-0.762,1.511-0.937,3.309-0.362,5.045c0.587,1.736,1.811,3.059,3.322,3.821
			c1.523,0.749,3.322,0.937,6.306-0.062l33.866-11.289c2.985-0.999,4.321-2.223,5.082-3.734
			C82.369,31.969,82.544,30.171,81.969,28.435z"/>
          <path d="M81.969,49.339c-0.587-1.736-1.811-3.059-3.322-3.821c-1.523-0.749-3.322-0.937-6.306,0.062L38.475,56.869
			c-2.997,0.999-4.321,2.223-5.082,3.734c-0.762,1.511-0.937,3.309-0.362,5.045c0.587,1.736,1.811,3.059,3.322,3.821
			c1.523,0.749,3.322,0.937,6.306-0.062l33.866-11.289c2.985-0.999,4.321-2.223,5.082-3.734
			C82.369,52.873,82.544,51.075,81.969,49.339z"/>
          <path d="M81.969,70.256c-0.587-1.736-1.811-3.059-3.322-3.821c-1.523-0.749-3.322-0.937-6.306,0.062L38.475,77.786
			c-2.997,0.999-4.321,2.223-5.082,3.734c-0.762,1.511-0.937,3.309-0.362,5.045c0.587,1.736,1.811,3.059,3.322,3.821
			c1.523,0.749,3.322,0.937,6.306-0.062l33.866-11.289c2.985-0.999,4.321-2.223,5.082-3.734
			C82.369,73.79,82.544,71.992,81.969,70.256z"/>
        </g>
      </g>
    </svg>
  );
};

export default EricssonLogo;
